export default "__VITE_ASSET__CaV6lFhx__"